
document.addEventListener('DOMContentLoaded', function () {
    const tabsSections = document.querySelectorAll('.js-section-tabs-block');

    tabsSections.forEach((accordion) => {
        const panels = document.querySelectorAll('.section-tabs-block__panel');
        const headers = document.querySelectorAll('.section-tabs-block__header');
        const arrows = document.querySelectorAll('.section-tabs-block__arrow');

        let autoSwitchTimer = null; // Przechowuje aktualny setTimeout (aby móc wyczyścić)

        function resetAndStartProgressBar(index) {
            // Pobieramy pasek postępu
            const currentPanel = panels[index];
            const progressBar = currentPanel.querySelector('.section-tabs-block__progress-bar');
            if (!progressBar) return;

            // Jeżeli chcemy w ogóle wyłączyć pasek na < 1000px:
            if (window.innerWidth <
                992) {
                // W razie czego chowamy lub resetujemy pasek
                progressBar.style.width = '0';
                progressBar.style.transition = 'none';
                return;
            }

            // 1) Reset animacji
            progressBar.style.transition = 'none';
            progressBar.style.width = '0';

            // 2) Wymuszamy reflow
            void progressBar.offsetWidth;

            // 3) Uruchamiamy płynny wzrost w 10s
            progressBar.style.transition = 'width 10s linear';
            progressBar.style.width = '100%';
        }


        function updateTabs(index) {
            // 1) Jeśli mieliśmy uruchomiony poprzedni timer, czyścimy go
            if (autoSwitchTimer) {
                clearTimeout(autoSwitchTimer);
            }

            // 2) Deaktywujemy wszystkie panele
            panels.forEach((panel) => {
                panel.classList.remove('is-active');
                const bar = panel.querySelector('.section-tabs-block__progress-bar');
                if (bar) {
                    bar.style.transition = 'none';
                    bar.style.width = '0';
                }
            });

            // 3) Aktywujemy wybrany panel
            panels[index].classList.add('is-active');

            // 4) Uruchamiamy animację paska w aktywnym panelu
            resetAndStartProgressBar(index);

            // 5) Tylko przy szerokości >= 1000px ustawiamy automatyczne przełączenie
            if (window.innerWidth >= 992) {
                autoSwitchTimer = setTimeout(() => {
                    const newIndex = (index + 1) % panels.length;
                    updateTabs(newIndex);
                }, 10000); // 10s
            }
        }


        // Obsługa strzałek (prev / next)
        panels.forEach((panel, panelIndex) => {
            const prevButton = panel.querySelector('.section-tabs-block__arrow--prev');
            const nextButton = panel.querySelector('.section-tabs-block__arrow--next');

            prevButton?.addEventListener('click', function () {
                const newIndex = (panelIndex - 1 + panels.length) % panels.length;
                updateTabs(newIndex);
            });

            nextButton?.addEventListener('click', function () {
                const newIndex = (panelIndex + 1) % panels.length;
                updateTabs(newIndex);
            });
        });

        // Obsługa kliknięcia w nagłówek taba
        headers.forEach((header, index) => {
            header.addEventListener('click', function () {
                updateTabs(index);
            });
        });

        // Na starcie (np. wczytanie strony) ustawiamy panel pierwszy (0) jako aktywny
        updateTabs(0);
    });
});
